import * as React from 'react';
import { PercentSlider } from '../parts/RatioSlider';
import { BreakEvenAmountsModel, defaultStore } from '../../data/dataStore';
import { formatPercent, currencyFormat, numberWithCommas, getGenreBasedMixes } from '../../helpers';
import { TheBrain } from '../../data/brain';

export interface BreakdownProps {
    data: BreakEvenAmountsModel;
    onChanged: (m: BreakEvenAmountsModel) => void;
    brain: TheBrain;
}





export const Breakdown = (props: BreakdownProps) => {

    const { data, onChanged, brain } = props;

    const renderSlidyForm = (title: string, subTitle: any, ratio: number, total: number, fun: (m: BreakEvenAmountsModel, v: number) => void) => {
        return <div className="beeom-slider-form">
            <span className="top-row">
                <span className="title">{title}</span>
                <span className="total">{numberWithCommas(total, 0)}</span>
            </span>
            <span className="subtitle">{subTitle}</span>
            <span className="slider-row">
                <span className="slider">
                    <PercentSlider
                        defaultRatio={ratio}
                        onChange={v => {
                            const d = { ...data };
                            const vv = fun(d, v);
                            onChanged(d);
                        }}
                    />
                </span>
                <span className="percent">{formatPercent(ratio, 1)}</span>
            </span>
        </div>
    }




    return <div className="breakdown">
        {renderSlidyForm(
            "Streaming",
            <span>Mix of <strong>streaming</strong> income vs other income</span>,
            data.streamingRatio,
            brain.getStreamingUnits(),
            (m, v) => m.streamingRatio = v
        )}

        {renderSlidyForm(
            "Track Downloads",
            <span>Mix of <strong>track</strong> income vs album income</span>,
            data.trackVsAlbumsRatio,
            brain.getTrackDownloadUnits(),
            (m, v) => m.trackVsAlbumsRatio = v
        )}

        {renderSlidyForm(
            "Album Downloads",
            <span>Mix of <strong>digital album</strong> income vs physical album income</span>,
            data.digitalVsPhysicalRatio,
            brain.getAlbumDownloadUnits(),
            (m, v) => m.digitalVsPhysicalRatio = v
        )}

        <div className="beeom-slider-form">
            <span className="top-row">
                <span className="title">Physical Albums</span>
                <span className="total">{numberWithCommas(brain.getPhysicalAlbumUnits(), 0)}</span>
            </span>
        </div>

        <div style={{ textAlign: "right" }}>
            <button
                className="blue-button"
                onClick={e => onChanged(getGenreBasedMixes(brain.data.info.genre))}>
                Reset Mix
            </button>
        </div>

    </div>

}